/* VUE
-------------------------------------------------------------- */
import Vue from 'vue';

/* VUEX
-------------------------------------------------------------- */
import Vuex from 'vuex';

Vue.use(Vuex);

/* VUE-AXIOS
-------------------------------------------------------------- */
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(Vuex, VueAxios, axios);

/* MODULES
-------------------------------------------------------------- */
// import { AlertNotificationData } from './notifications/alertNotification'

// import {
//   // SVG
//   emptyIcon,
//   lockIcon,
//   logoutIcon,
//   mailIcon,
//   checkmarkIcon,
//   userIcon,
//   plusIcon,
//   warningIcon,
// } from '@deanone/dean-components';


import main from './main';
import menu from './menu';
import partners from './partners';
import customers from './customers';
import login from './login';
import standingData from './standingData';
import orders from './orders';

/* THEMES
-------------------------------------------------------------- */
import { ThemesData } from './themes/themes';

/* STORE
-------------------------------------------------------------- */
export default new Vuex.Store({
  strict: false,
  modules: {
    main,
    menu,
    partners,
    customers,
    login,
    standingData,
    orders,
    ThemesData,
  },
});

// --- TYPESCRIPT STORE EXAMPLE ---

// https://codeburst.io/vuex-and-typescript-3427ba78cfa8
// https://github.com/mrcrowl/vuex-typex

// import Vue from 'vue';
// import Vuex, { StoreOptions } from 'vuex';
// import { RootState } from './types';
// import { nmap } from './nmap/index';
//
// Vue.use(Vuex);
//
// const store: StoreOptions<RootState> = {
//   state: {
//     version: '1.0.0',
//   },
//   modules: {
//     nmap,
//   },
// };
//
// export default new Vuex.Store<RootState>(store);
